export const WIN_MESSAGES = ['Kwoli Kiseht!']
